import { Box, Typography } from "@mui/material";
import GlassModal from "../../../v2/MUI_custom_component/Modal/GlassModal";
import { CustomButton } from "../../../v2/MUI_custom_component";
import IllustrationWrapper from "../../Illustrration/IllustrationWrapper";
import DisclaimerSvg from "../../Illustrration/components/DisclaimerSvg";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getUserFirmsAction } from "../../../v2/MyAccount/APIs/action";
import { toast } from "react-toastify";

export const FirmManufactureModal =({setManufacturerModal, firmModal,setFirmModal,manufacturerModal}) =>{
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { selected_firm } = useSelector((state) => ({
      selected_firm: state.dashboardReducer.selected_firm,
    }));

    const allFirms = async () => {
      const { data, error, message } = await getUserFirmsAction();
      if (!error) {
        if (selected_firm && data && data.length > 0) {
          const selectedFirmData = data.find(firm => String(firm.firm_id) === String(selected_firm));
          if (selectedFirmData) {
            const address = selectedFirmData.address || {};
            const gstDetails = {
              gst_number: selectedFirmData.firm_gstin || null,
              pan_number: selectedFirmData.firm_pan || null,
              firm_name: selectedFirmData.firm_name || null,
              address_line_1: address.address_line_1 || null,
              address_line_2: [address.address_line_2, address.address_line_3].filter(Boolean).join(' ') || null,
              state_id: address.state_id || null,
              state_name: address.state_name || null,
              pincode_id: address.pincode || null,
              district_id: address.district_id || null,
              district_name: address.district_name || null,
              location_id: address.location_id || null,
              location_name: address.location_name || null,
            };
            dispatch({ type: 'SET_GST_DETAILS', payload: gstDetails });
            dispatch({ type: 'SET_OPERATIONAL_DETAILS', payload: gstDetails });
            dispatch({ type: 'SET_GST_NUMBER', payload: selectedFirmData.firm_gstin });
          }
        }
      } else {
        return toast.error(message);
      }
    };

    const handleManufacturerAdd = () => {
      dispatch({ type: 'RESET_FIRM_ONBOARDING' });
      setManufacturerModal(false);
      allFirms();
      dispatch({ type: 'SET_EXISTING_FIRM', payload: true  });
      navigate('/firm-onboarding/select-manufacturer'); 
    }
    return <>
    <GlassModal
        maxWidth = '600px'
        showHeader={false}
        open={firmModal}
        onClose={() => setFirmModal(false)}
        topMobile = '40%'
        scrollable = {true}
        maxHeight = '40%'
      >
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          justifyContent: 'center', 
          py: 2, 
          gap: 2 
        }}>
          <Box
            component='img'
            src='https://d2djimvzddgguw.cloudfront.net/onboarding/add-firm.svg'
            alt='Account Details'
            sx={{ width: '100%', maxHeight: 200, objectFit: 'contain' }}
          />
          <Typography variant='h1' sx={{ textAlign: 'center', minWidth: {xs: '270px', md: 'unset'}}}>Add your firm to unlock growth opportunities</Typography>
          <Typography variant='body1' sx={{ textAlign: 'center'}}>You can use the entire app and all the features we have once you add your firm on HUMBEE</Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1}}>
          <CustomButton
            fullWidth
            variant='filled'
            label='Add Firm'
            onClick={() => {
              setFirmModal(false);
              navigate('/firm-onboarding/select-manufacturer'); 
            }}
          />
          <CustomButton
            fullWidth
            color='primary'
            variant='text'
            label='Do it later'
            onClick={() => {
              setFirmModal(false);
            }}
          />
        </Box>
      </GlassModal>
      <GlassModal
        maxWidth = '600px'
        topMobile = '50%'
        scrollable = {true}
        maxHeight = '50%'
        showHeader={false}
        open={manufacturerModal}
        onClose={() => setManufacturerModal(false)}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4}}>
        <IllustrationWrapper
          illustration={<DisclaimerSvg />}
          title="Add a manufacturer to begin"
          subtitle="You can use all the features once you add manufacturers you work with on HUMBEE"
        />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1}}>
          <CustomButton
            fullWidth
            variant='filled'
            label='Add Manufacturer'
            onClick={handleManufacturerAdd}
          />
          <CustomButton
            fullWidth
            color='primary'
            variant='text'
            label='Do it later'
            onClick={() => {
              setManufacturerModal(false);
            }}
          />
        </Box>
        </Box>
      </GlassModal>
    </>
}